module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/scholarship_payments/download_report', 'Payments.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCheckUniversityFeesOk.show()
            }
          }
        }, [_vm._v("Check University Fees")]), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentOk.show()
            }
          }
        }, [_vm._v("Export Payments")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/scholarship_payments/download_kit_report', 'KIT_Payments.xlsx')
            }
          }
        }, [_vm._v("Export KIT Payments")]) : _vm._e(), _vm._v(" "), (_vm.isPlanned && _vm.privUser) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCreatePaymentOk.show()
            }
          }
        }, [_vm._v("Schedule Payments")]) : _vm._e()], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privAdministrator) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), (_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSchedulePaymentOk.show()
            }
          }
        }, [_vm._v("Schedule Payments")]) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Contract - Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Planned before",
      "type": "date",
      "field": "planned_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y1",
      "field": "y1_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Exported after",
      "type": "date",
      "field": "exported_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Ready for export",
      "field": "ready_for_export",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Type",
      "field": "scholarship_payment_type_id",
      "optionListApiUrl": '/scholarship_payment_types/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalExportPaymentOk",
    attrs: {
      "title": "Export Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.exportPayments
    }
  }, [_vm._v("\n    Are you sure you want to export these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalSchedulePaymentOk",
    attrs: {
      "title": "Schedule Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.createBatchPayments, 'document_reference')
      }
    }
  }, [_vm._v("\n    Are you sure you want to schedule these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalCheckUniversityFeesOk",
    attrs: {
      "title": "Check University Fees",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.checkUniversityFees
    }
  }, [_vm._v("\n    Are you sure you want to check the university payments?\n    "), _c('b-form-fieldset', {
    attrs: {
      "label-text-align": "right",
      "label": "Period:",
      "horizontal": ""
    }
  }, [_c('b-form-input', {
    staticClass: "float-right",
    attrs: {
      "name": "universityFeePeriod",
      "type": "text"
    },
    model: {
      value: (_vm.universityFeePeriod),
      callback: function($$v) {
        _vm.universityFeePeriod = $$v
      },
      expression: "universityFeePeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalCreatePaymentOk",
    attrs: {
      "title": "Schedule Payments",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": _vm.createPayments
    }
  }, [_vm._v("\n    Are you sure you want to schedule these payments?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/scholarship_payments/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.bulkRec,
      "type": "money",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Payment Date",
      "field": "payment_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a76ff2f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ScholarshipPayment/Overview.vue
// module id = 718
// module chunks = 1